import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { catchError, tap } from 'rxjs/operators';
import { EMPTY, Observable } from 'rxjs';
import { CustomerService } from '../../customer-zone/services/customer-service.service';
import { PersonDetails } from '../../../shared/models/PersonDetailsModel';
import { HelperService } from 'src/app/shared/services/helper.service';
import { ContextService } from '../../context/services/context.service';
import { AgAuthenticationService } from '@ag/vc.ag-core/authentication';

@Injectable({
  providedIn: 'root'
})
export class PersonDetailsResolverService {

  constructor(
    private customerService: CustomerService,
    private authenticationService: AgAuthenticationService,
    private helper : HelperService, 
    private contextService : ContextService,
  ) { }

  // eslint-disable-next-line @typescript-eslint/no-redundant-type-constituents
  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<PersonDetails | unknown> {    
    if (this.authenticationService.isAuthenticated && Number(localStorage.personId)){
      const personDetails = this.customerService.getCustomerDetails();
      if (!personDetails){
        const message = {
          Uci: localStorage.getItem('uci'),
          AccessToken: this.authenticationService.accessToken
        }         
        this.contextService.logAccessTokenErrorInDB(`ONE MSA retrievepersondetails API: ${JSON.stringify(message)}`);
        return this.customerService.getCustomerDetailsFromDB(Number(localStorage.personId)).pipe(
          tap((personDetails: PersonDetails) => {
            this.customerService.setCustomerDetails(personDetails);
          }),
          catchError((_error) => {
            return EMPTY;
          })
        );
      }
      return new Observable<PersonDetails>((observer) => {
        observer.next(personDetails);
        observer.complete();
      });
    }else{
      return EMPTY;
    }
  }
}
